import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  createApiRef,
  oauthRequestApiRef,
  discoveryApiRef,
  gitlabAuthApiRef,
  OAuthApi,
  OpenIdConnectApi,
  ProfileInfoApi,
  BackstageIdentityApi,
  SessionApi,
} from '@backstage/core-plugin-api';
import { OAuth2 } from '@backstage/core-app-api';

export const keycloakAuthApiRef = createApiRef<
  OAuthApi & OpenIdConnectApi & ProfileInfoApi & BackstageIdentityApi & SessionApi
>({
  id: 'auth.keycloak',
});

// gitlabAuthApiRef stub — immobiliarelabs/backstage-plugin-gitlab이 dep으로 요구하지만
// OAuth를 사용하지 않으므로 (useOAuth: false) 실제 호출되지 않음.
// 없으면 플러그인 DI 해석 실패로 CI/CD 탭 전체가 깨짐.
const gitlabAuthStub = {
  getAccessToken: async () => '',
  getIdToken: async () => ({ token: '', payload: {} }),
  getBackstageIdentity: async () => ({
    type: 'user' as const,
    userEntityRef: 'user:default/guest',
    ownershipEntityRefs: [],
  }),
  getProfile: async () => ({}),
  signIn: async () => {},
  signOut: async () => {},
  sessionState$: () =>
    ({ subscribe: () => ({ unsubscribe: () => {} }) }) as any,
};

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: gitlabAuthApiRef,
    deps: {},
    factory: () => gitlabAuthStub as any,
  }),
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
  createApiFactory({
    api: keycloakAuthApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      oauthRequestApi: oauthRequestApiRef,
      configApi: configApiRef,
    },
    factory: ({ discoveryApi, oauthRequestApi, configApi }) => {
      const env =
        configApi.getOptionalString('auth.environment') ?? 'development';
      const providerConfig =
        configApi
          .getOptionalConfig(`auth.providers.keycloak.${env}`) ?? undefined;
      return OAuth2.create({
        discoveryApi,
        oauthRequestApi,
        configApi: providerConfig ?? configApi,
        environment: env,
        defaultScopes: ['openid', 'profile', 'email'],
        provider: {
          id: 'keycloak',
          title: 'Arcus SSO',
          icon: () => null,
        },
      });
    },
  }),
];
